import React from 'react';
import CajaHoras from '../components/Horas/CajaHoras';
import '../components/Horas/EstilosPantallasHoras.css'



const Horas = (props) => {
	return (
		<div className="container_Pantalla_Horas">
			<CajaHoras />
		</div>
	
		
	)
}

export default Horas;
